<template>
  <div class="subtitle">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";

$subtitle-gap: 8px;

.subtitle {
  display: flex;
  flex-direction: row;
  align-items: center;

  > * {
    display: flex;
    align-items: center;
    flex-shrink: 0;

    &:not(:first-child) {
      padding-left: $subtitle-gap;
    }

    &:not(:last-child)::after {
      content: "";
      width: 1px;
      height: 8px;
      background-color: colors.$border-subtle;
      border-radius: 1px;
      margin-left: $subtitle-gap;
    }
  }
}
</style>
